import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getPurities = async () => {
  // const response = await axios.get(`${base_url}purity/all`);
  const response = await axios.get(`${base_url}purity/all`, getAuthHeaders());
  return response.data;
};

const createPurity = async (purity) => {
  // const response = await axios.post(`${base_url}purity/add`, purity, config);
  const response = await axios.post(`${base_url}purity/add`, purity, getAuthHeaders());
  console.log("Hello",response.data)
  return response.data;
};
const updatePurity = async (purity) => {
  const response = await axios.put(
    `${base_url}purity/edit/${purity.id}`,
    { product_purity: purity.purityData.product_purity,
      metal_type: purity.purityData.metal_type,
     },
     getAuthHeaders()
  );

  return response.data;
};
const getPurity = async (id) => {
  const response = await axios.get(`${base_url}purity/get/${id}`, getAuthHeaders());

  return response.data;
};

const deletePurity = async (id) => {
  const response = await axios.delete(`${base_url}purity/delete/${id}`, getAuthHeaders());

  return response.data;
};

const purityService = {
  getPurities,
  createPurity,
  getPurity,
  updatePurity,
  deletePurity,
};

export default purityService;
